import * as React from 'react';
import type { FormInputEvent } from 'utils/form/Form.types';
import NoodleButton from 'components/uielements/Button';
import ButtonOptionsWrapper from './ButtonOptions.style';
import type { ButtonOptionsProps } from './ButtonOptions.types';

const ButtonOptions = ({
  disabled,
  name,
  onChange,
  options = [],
  value: data,
}: ButtonOptionsProps) => {
  const [selectedValue, setSelectedValue] = React.useState(data);

  const handleOnClick = ({ currentTarget: { value } }: FormInputEvent) => {
    setSelectedValue(value);
    onChange({
      currentTarget: {
        name,
        value,
      },
    });
  };

  const renderOptions = (): React.ReactElement<any>[] =>
    options.map(({ label, value }) => {
      const color = value === selectedValue ? 'primary' : 'secondary';
      return (
        <NoodleButton
          disabled={disabled}
          className='button-options__item'
          color={color}
          key={value}
          onClick={handleOnClick}
          size='small'
          value={value}
        >
          {label}
        </NoodleButton>
      );
    });

  return <ButtonOptionsWrapper>{renderOptions()}</ButtonOptionsWrapper>;
};

export default ButtonOptions;
